export const PLANT = 'Plant';
export const PLANTER = 'Planter';
export const SOIL_MIXING = 'Soil Mixing';
